/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCarrierDTO interface.
 */
export function instanceOfWarehouseCarrierDTO(value) {
    return true;
}
export function WarehouseCarrierDTOFromJSON(json) {
    return WarehouseCarrierDTOFromJSONTyped(json, false);
}
export function WarehouseCarrierDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'serviceName': json['serviceName'] == null ? undefined : json['serviceName'],
        'type': json['type'] == null ? undefined : json['type'],
        'minDays': json['minDays'] == null ? undefined : json['minDays'],
        'maxDays': json['maxDays'] == null ? undefined : json['maxDays'],
        'maxWeightLbs': json['maxWeightLbs'] == null ? undefined : json['maxWeightLbs'],
        'startingPriceUsd': json['startingPriceUsd'] == null ? undefined : json['startingPriceUsd'],
    };
}
export function WarehouseCarrierDTOToJSON(json) {
    return WarehouseCarrierDTOToJSONTyped(json, false);
}
export function WarehouseCarrierDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'serviceName': value['serviceName'],
        'type': value['type'],
        'minDays': value['minDays'],
        'maxDays': value['maxDays'],
        'maxWeightLbs': value['maxWeightLbs'],
        'startingPriceUsd': value['startingPriceUsd'],
    };
}
